import { paiseToInrExact } from "../../lib/format.ts";

/**
 * Exact rupee string for a nullable paise amount; em-dash when absent.
 *
 * Delegates to the app-wide `paiseToInrExact`, which parses with `BigInt` —
 * the store previously carried its own copy in two files that ran `Number()`
 * over a stringified bigint and lost precision on large amounts.
 */
export function paiseOrDash(paise: string | null): string {
  return paise === null ? "—" : paiseToInrExact(paise);
}
